/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { FlyKeyboardEvent } from '@customerio/fly-components/types/fly-components/events';

export default class CampaignsCampaignExitSetupLegacyOptionsFeedbackModal extends Component<HelpModalComponentArgs> {
  @tracked suggestion = '';

  get isSubmitDisabled() {
    return this.suggestion.trim() === '';
  }

  @action
  onSubmitAction(e: Event) {
    e.preventDefault();

    this.args.onSubmit({
      criticism: 'Legacy exit conditions feedback',
      praise: this.suggestion.trim(),
    });
  }

  @action
  updateSuggestion(evt: FlyKeyboardEvent<HTMLTextAreaElement>) {
    this.suggestion = evt.target.value;
  }
}
